import AdminUpdatePasein from "../../components/AdminPurchaseRequest/AdminPurchaseRequestUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
